import { getInstance } from './auth0-plugin'
import { setAnalyticsUser } from '@/plugins/analytics'

const maintenance = JSON.parse(process.env.VUE_APP_MAINTENANCE_STATUS)

export const authGuard = (to, from, next) => {
  const authService = getInstance()

  const guardAction = () => {
    if (authService.isAuthenticated) {
      setAnalyticsUser(authService.userGroups)
      if (authService.tenantTitle) {
        document.title = `${authService.tenantTitle} | ${to.meta?.title}`
      }
      if (maintenance) {
        if (to.path !== '/') return next('/')
        else return next()
      }
      return next()
    }
    const options = { appState: { targetUrl: to.fullPath } }
    authService.loginWithRedirect({ ...options })
  }

  // If the Auth0Plugin has loaded already, check the authentication state
  if (!authService.isLoading) {
    return guardAction()
  }

  authService.$watch('isLoading', (isLoading) => {
    if (isLoading === false) {
      return guardAction()
    }
  })
}
